import {Component, ViewChild, Input, Output, EventEmitter, ElementRef, Renderer} from '@angular/core';
import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';
import * as firebase from 'firebase';
//import { NgUploaderOptions } from 'ngx-uploader';

@Component({
  selector: 'oa-picture-uploader',
  styleUrls: ['./oaPictureUploader.scss'],
  templateUrl: './oaPictureUploader.html',
})
export class OaPictureUploader {

  @Input() defaultPicture:string = '';
  @Input() picture:string = '';

  @Input() uploaderOptions = { location: '' };
  @Input() canDelete:boolean = true;

  @Output() onUpload = new EventEmitter<any>();
  @Output() onUploadCompleted = new EventEmitter<any>();
  @Output() newPhoto = new EventEmitter<File>();

  @ViewChild('fileUpload') public _fileUpload:ElementRef;

  storageRef = firebase.storage().ref();

  public uploadInProgress:boolean;

  constructor(private renderer: Renderer) {
  }

  beforeUpload(uploadingFile): void {
    let files = this._fileUpload.nativeElement.files;

    if (files.length) {
      const file = files[0];
      this._changePicture(file);

      if (!this._canUploadOnServer()) {
        uploadingFile.setAbort();
      } else {
        this.uploadInProgress = true;
    //  this.uploadFile(file);
        this.newPhoto.emit(file);
      }
    }
  }
  pictureLocation;
  //uploadFile(file: File) {
  //  this.pictureLocation = this.storageRef.child(this.uploaderOptions.location);
  //  this.pictureLocation.child().put(file.name);
  //}

  public fileChangeEvent(fileInput: any){
      if (fileInput.target.files && fileInput.target.files[0]) {
        const reader = new FileReader();
        const selectedFile = fileInput.target.files[0];
        console.log(selectedFile);
        reader.addEventListener('load', (event:Event) => {
          this.picture = (<any> event.target).result;
        }, false);
        reader.readAsDataURL(fileInput.target.files[0]);
        this.sendPhoto(selectedFile);
        //this.newPhoto.emit(selectedFile);
    }
}

sendPhoto(file: File) {
  console.log('sending file');
  this.newPhoto.emit(file);
}

  bringFileSelector():boolean {
    this.renderer.invokeElementMethod(this._fileUpload.nativeElement, 'click');
    return false;
  }

  removePicture():boolean {
    this.picture = '';
    return false;
  }

  _changePicture(file:File):void {
    const reader = new FileReader();
    reader.addEventListener('load', (event:Event) => {
      this.picture = (<any> event.target).result;
    }, false);
    reader.readAsDataURL(file);
  }

  _onUpload(data):void {
    if (data['done'] || data['abort'] || data['error']) {
      this._onUploadCompleted(data);
    } else {
      this.onUpload.emit(data);
    }
  }

  _onUploadCompleted(data):void {
    this.uploadInProgress = false;
    this.onUploadCompleted.emit(data);
  }

  _canUploadOnServer():boolean {
    return !!this.uploaderOptions['location'];
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/components/oaPictureUploader/oaPictureUploader.component.ts